const menuList = (t) => {
  return [
    {
      title: t('home'),
      nivel: 0,
      icon: 'svguse:#icon_home',
      name: 'home_admin',
      show: true,
    },
  ]
}

export default menuList
